import type { ReactNode } from 'react'

import estilos from './Estados.module.css'

type PropsSinDatos = {
  titulo: string
  /** Qué hacer para que deje de estar vacío. Una lista vacía sin salida frustra. */
  mensaje?: string
  accion?: ReactNode
  simbolo?: string
}

export function SinDatos({ titulo, mensaje, accion, simbolo = '·' }: PropsSinDatos) {
  return (
    <div className={estilos.centro}>
      <span className={estilos.icono} aria-hidden="true">
        {simbolo}
      </span>

      <p className={estilos.titulo}>{titulo}</p>
      {mensaje && <p className={estilos.mensaje}>{mensaje}</p>}
      {accion}
    </div>
  )
}
